export default {
      id: "event-users-header-usage",
      viewBox: "0 0 73 55",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#event-users-header",
      toString: function () {
        return this.url;
      }
    }